import { render } from "./completedContents.vue?vue&type=template&id=3a21ea94&scoped=true"
import script from "./completedContents.vue?vue&type=script&lang=js"
export * from "./completedContents.vue?vue&type=script&lang=js"

import "./completedContents.vue?vue&type=style&index=0&id=3a21ea94&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a21ea94"]])

export default __exports__